<template>
  <div class="member-agreement">
    <div class="inner-container">
      <h2>회원가입</h2>
      <div class="agreement-container">
        <hr />
        <div class="checkbox-container">
          <div>
            <input id="terms" type="checkbox" v-model="checks.terms" />
          </div>
          <div class="label-container">
            <label for="terms" class="bold">이용약관 동의 (필수)</label>
          </div>
          <button @click="openDialog('AGREEMENT_TERMS')">보기</button>
        </div>
        <div class="checkbox-container">
          <div>
            <input
              id="privacy-required"
              type="checkbox"
              v-model="checks.privacyRequired"
            />
          </div>
          <div class="label-container">
            <label for="privacy-required" class="bold">
              개인정보 수집 및 이용 동의 (필수)
            </label>
          </div>
          <button @click="openDialog('AGREEMENT_PRIVACY')">보기</button>
        </div>
        <div class="checkbox-container">
          <div>
            <input id="gps" type="checkbox" v-model="checks.gps" />
          </div>
          <div class="label-container">
            <label for="gps" class="bold">
              위치기반서비스 이용약관 동의 (필수)
            </label>
          </div>
          <button @click="openDialog('AGREEMENT_GPS')">보기</button>
        </div>
        <div class="checkbox-container">
          <div>
            <input id="marketing" type="checkbox" v-model="checks.marketing" />
          </div>
          <div class="label-container">
            <label for="marketing" class="bold"
              >마케팅 목적의 개인정보 수집 및 이용 (필수)</label
            >
          </div>
          <button @click="openDialog('AGREEMENT_MARKETING')">보기</button>
        </div>
        <div class="checkbox-container">
          <div>
            <input id="sms" type="checkbox" v-model="checks.sms" />
          </div>
          <div class="label-container">
            <label for="sms" class="bold">
              쇼핑정보 SMS / 알림톡 수신 동의 (필수)
            </label>
          </div>
          <button @click="openDialog('AGREEMENT_SMS')">보기</button>
        </div>
        <hr />
      </div>
      <div class="join-container">
        <h3>기본 로그인 정보 입력</h3>
        <div class="input-container rrn">
          <p>휴대폰 번호<span>*</span></p>
          <div>
            <input
              type="text"
              v-model="phone1Text"
              inputmode="numeric"
              maxlength="3"
              placeholder="010"
              :disabled="isNotPhoneDuplicated"
              @input="(e) => onlyNumber(e, 'phone1Text')"
            />
            <p>-</p>
            <input
              type="text"
              v-model="phone2Text"
              inputmode="numeric"
              maxlength="4"
              placeholder="1234"
              :disabled="isNotPhoneDuplicated"
              @input="(e) => onlyNumber(e, 'phone2Text')"
            />
            <p>-</p>
            <input
              type="text"
              v-model="phone3Text"
              inputmode="numeric"
              maxlength="4"
              placeholder="5678"
              :disabled="isNotPhoneDuplicated"
              @input="(e) => onlyNumber(e, 'phone3Text')"
            />
          </div>
          <button
            class="side-button"
            @click="handleCheckPhoneNumber"
            :disabled="isNotPhoneDuplicated"
          >
            중복확인
          </button>
        </div>
        <div class="input-container">
          <p>비밀번호<span>*</span></p>
          <input
            type="password"
            maxlength="16"
            v-model="passwordText"
            placeholder="8 ~ 16자, 영문 대·소문자/숫자/특수문자 포함"
            @input="validatePassword"
          />
          <p class="error" v-if="passwordError">{{ passwordError }}</p>
        </div>
        <div class="input-container">
          <p>비밀번호 확인<span>*</span></p>
          <input
            type="password"
            maxlength="16"
            v-model="password2Text"
            placeholder="비밀번호를 다시 입력해주세요"
            @input="validatePassword2"
          />
          <p class="error" v-if="password2Error">{{ password2Error }}</p>
        </div>
        <hr class="sub" />
        <h3>가입자 본인인증</h3>
        <img src="@/assets/resident_guide.png" />
        <div class="input-container">
          <p>이름<span>*</span></p>
          <input
            type="text"
            v-model="verifyNameText"
            :disabled="isSuccessLogin || isRequestLogin"
            placeholder="①번 항목"
          />
        </div>
        <div class="input-container rrn">
          <p>주민등록번호<span>*</span></p>
          <div>
            <input
              type="text"
              v-model="verifyRrn1Text"
              maxlength="6"
              :disabled="isSuccessLogin || isRequestLogin"
              placeholder="②번 항목"
              @input="(e) => onlyNumber(e, 'verifyRrn1Text')"
            />
            <p>-</p>
            <input
              type="password"
              v-model="verifyRrn2Text"
              maxlength="7"
              :disabled="isSuccessLogin || isRequestLogin"
              placeholder="③번 항목"
              @input="(e) => onlyNumber(e, 'verifyRrn2Text')"
            />
          </div>
        </div>
        <div class="input-container">
          <p>발급일자<span>*</span></p>
          <input
            type="date"
            v-model="verifyIssueDate"
            :disabled="isSuccessLogin || isRequestLogin"
          />
        </div>
        <div class="input-container">
          <p>간편인증 종류<span>*</span></p>
          <select
            v-model="loginTypeText"
            :disabled="isSuccessLogin || isRequestLogin"
          >
            <option value="">== 인증서 선택 ==</option>
            <option value="1">카카오 인증서</option>
            <option value="3">삼성패스</option>
            <option value="4">KB 모바일인증서</option>
            <option value="5">통신사 (PASS)</option>
            <option value="6">네이버 인증서</option>
            <option value="7">신한 인증서</option>
            <option value="8">토스 인증서</option>
            <option value="9">하나 인증서</option>
            <option value="10">NH 인증서</option>
          </select>
        </div>
        <div class="input-container" v-if="loginTypeText == '5'">
          <p>통신사<span>*</span></p>
          <select
            v-model="carrierText"
            :disabled="isSuccessLogin || isRequestLogin"
          >
            <option value="">== 통신사 선택 ==</option>
            <option value="0">SKT (SKT 알뜰폰)</option>
            <option value="1">KT (KT 알뜰폰)</option>
            <option value="2">LG U+ (LG U+ 알뜰폰)</option>
          </select>
        </div>
        <!-- goto -->
        <div class="input-container">
          <button
            :disabled="isSuccessLogin || isRequestLogin"
            @click="handleRequestLogin"
          >
            위의 정보로 인증 요청하기
          </button>
          <button
            :disabled="isSuccessLogin || !isRequestLogin"
            @click="handleSuccessLogin"
          >
            인증 완료하기
          </button>
        </div>
        <hr class="sub" />
        <h3>기본 배송지 정보 입력</h3>
        <div class="input-container rrn">
          <p>우편번호<span>*</span></p>
          <div>
            <input
              type="text"
              v-model="postCodeText"
              placeholder="우편번호"
              disabled
            />
            <button class="side-button" @click="openDaumPostcode">
              주소검색
            </button>
          </div>
        </div>
        <div class="input-container">
          <p>기본 주소<span>*</span></p>
          <input
            type="text"
            v-model="address1Text"
            placeholder="기본 주소"
            disabled
          />
        </div>
        <div class="input-container">
          <p>나머지 주소<span>*</span></p>
          <input
            type="text"
            v-model="address2Text"
            placeholder="상세 주소 입력"
          />
        </div>
        <hr class="sub" />
        <h3>환불 정보 입력</h3>
        <div class="input-container">
          <p>은행명<span>*</span></p>
          <select v-model="bankNameText">
            <option value="">== 은행명 선택 ==</option>
            <option value="NH농협은행">NH농협은행</option>
            <option value="카카오뱅크">카카오뱅크</option>
            <option value="KB국민은행">KB국민은행</option>
            <option value="토스뱅크">토스뱅크</option>
            <option value="신한은행">신한은행</option>
            <option value="우리은행">우리은행</option>
            <option value="IBK기업은행">IBK기업은행</option>
            <option value="하나은행">하나은행</option>
            <option value="새마을금고">새마을금고</option>
            <option value="부산은행">부산은행</option>
            <option value="iM뱅크">iM뱅크</option>
            <option value="케이뱅크">케이뱅크</option>
            <option value="신협">신협</option>
            <option value="우체국">우체국</option>
            <option value="SC제일은행">SC제일은행</option>
            <option value="경남은행">경남은행</option>
            <option value="광주은행">광주은행</option>
            <option value="수협">수협</option>
            <option value="전북은행">전북은행</option>
            <option value="저축은행">저축은행</option>
            <option value="제주은행">제주은행</option>
            <option value="씨티은행">씨티은행</option>
            <option value="KDB산업은행">KDB산업은행</option>
            <option value="산림조합은행">산림조합은행</option>
            <option value="SBI저축은행">SBI저축은행</option>
          </select>
        </div>
        <div class="input-container">
          <p>계좌번호<span>*</span></p>
          <input
            type="text"
            v-model="bankAccountNumberText"
            maxlength="20"
            placeholder="숫자만 입력 가능"
            @input="(e) => onlyNumber(e, 'bankAccountNumberText')"
          />
        </div>
        <div class="input-container">
          <p>예금주<span>*</span></p>
          <input type="text" v-model="bankDepositorNameText" />
        </div>
        <hr class="sub" />
        <h3>영업자 정보 입력</h3>
        <div class="input-container rrn">
          <p>영업자 코드 (선택)</p>
          <div>
            <input
              type="text"
              v-model="salespersonCodeText"
              :disabled="isCheckedSalespersonCode"
              maxlength="8"
              placeholder="예) NKS00000"
              @input="(e) => onlyNumberAndUpper(e, 'salespersonCodeText')"
            />
            <button
              class="side-button"
              @click="checkSalesPersonCode"
              :disabled="isCheckedSalespersonCode"
            >
              영업자 확인
            </button>
          </div>
        </div>
        <hr class="sub" />
        <div class="button-container">
          <button @click="router.go('/')">취소</button>
          <button @click="nextStep">회원가입</button>
        </div>
      </div>
    </div>
    <div v-if="isDialogOpened" class="overlay" @click="closeDialog">
      <div class="modal" @click.stop>
        <div class="title-container">
          <h3>{{ dialogTitle }}</h3>
          <button class="close-button" @click="isDialogOpened = false">
            <Icon size="24">
              <CloseRound />
            </Icon>
          </button>
        </div>
        <hr />
        <div class="content-container">
          <p v-html="dialogContent"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { db } from "@/lib/firebase";
import {
  addDoc,
  arrayUnion,
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  setDoc,
  Timestamp,
  updateDoc,
  where,
} from "firebase/firestore";
import { Icon } from "@vicons/utils";
import { CloseRound } from "@vicons/material";
import { nextTick, ref, onMounted } from "vue";
import router from "@/router";
import {
  convertRRNtoDate,
  generateUUIDFromSeed,
  isOverYear20,
} from "@/lib/utils";
import { encrypt } from "@/lib/crypto";
import { checkResidentCard } from "@/lib/codef";
import { loginProcess } from "@/lib/auth";
import { useRoute } from "vue-router";
import { useBusyLock } from "@/lib/useBusyLock";

const { runLocked } = useBusyLock();

const route = useRoute();

const isDialogOpened = ref(false);
const dialogTitle = ref("");
const dialogContent = ref("");

const phone1Text = ref("");
const phone2Text = ref("");
const phone3Text = ref("");
const isNotPhoneDuplicated = ref(false);

const passwordText = ref("");
const password2Text = ref("");

const passwordError = ref("");
const password2Error = ref("");

const verifyNameText = ref("");
// 주민등록증
const verifyRrn1Text = ref("");
const verifyRrn2Text = ref("");
const verifyIssueDate = ref("2026-01-01");
const loginTypeText = ref("");
const carrierText = ref("");

const isRequestLogin = ref(false);
const isSuccessLogin = ref(false);
const twoWayInfo = ref({});
const verifiedInfo = ref({});

const postCodeText = ref("");
const address1Text = ref("");
const address2Text = ref("");

const bankNameText = ref("");
const bankAccountNumberText = ref("");
const bankDepositorNameText = ref("");

const salespersonCodeText = ref("");
const isCheckedSalespersonCode = ref(false);

const checks = ref({
  terms: false,
  privacyRequired: false,
  gps: false,
  marketing: false,
  sms: false,
});

// --- 공통 유틸: 휴대폰 번호 문자열
const getPhoneText = () =>
  `${phone1Text.value}${phone2Text.value}${phone3Text.value}`;

// --- 공통 유틸: 주민번호 문자열
const getResidentIdentity = () =>
  `${verifyRrn1Text.value}${verifyRrn2Text.value}`;

// --- 공통 유틸: 통신사 선택이 필요한 로그인 타입인지 (정책에 맞게 값 유지)
// --- 현재 코드 기준: "5"일 때 통신사 필요
const needsCarrier = (loginType) => loginType === "5";

// --- 공통 유틸: CODEF 응답 파싱
const parseCodefResult = async (payload) => {
  const result = await checkResidentCard(payload);
  return typeof result === "string" ? JSON.parse(result) : result;
};

// --- 공통 유틸: 주민등록증 인증 payload 생성
const buildResidentPayload = ({ includeTwoWay = false } = {}) => {
  const convertIssueDate = verifyIssueDate.value.replaceAll("-", "");
  const telecom = needsCarrier(loginTypeText.value) ? carrierText.value : "";

  const payload = {
    organization: "0002",
    loginType: "6", // --- CODEF 로그인 타입 (고정값)
    loginTypeLevel: loginTypeText.value, // --- 사용자가 선택한 인증수단 레벨
    telecom,
    phoneNo: getPhoneText(),
    loginUserName: verifyNameText.value,
    loginIdentity: getResidentIdentity(),
    birthDate: "",
    identity: getResidentIdentity(),
    userName: verifyNameText.value,
    issueDate: convertIssueDate,
    identityEncYn: "N",
  };

  if (includeTwoWay) {
    payload.simpleAuth = "1";
    payload.is2Way = true;
    payload.twoWayInfo = twoWayInfo.value;
  }

  return payload;
};

// --- 숫자만 허용
const onlyNumber = (e, refName) => {
  const targetRef = {
    phone1Text,
    phone2Text,
    phone3Text,
    verifyRrn1Text,
    verifyRrn2Text,
    bankAccountNumberText,
  }[refName];

  if (!targetRef) return;

  const value = String(e.target.value || "").replace(/\D/g, "");
  targetRef.value = value;
  e.target.value = value;

  // --- 휴대폰 번호 변경 시 중복체크 다시 하게 초기화
  if (["phone1Text", "phone2Text", "phone3Text"].includes(refName)) {
    isNotPhoneDuplicated.value = false;
  }
};

// --- 영문 대문자 + 숫자만 허용
const onlyNumberAndUpper = (e, refName) => {
  const targetRef = {
    salespersonCodeText,
  }[refName];

  if (!targetRef) return;

  let value = String(e.target.value || "");
  value = value.toUpperCase().replace(/[^A-Z0-9]/g, "");

  targetRef.value = value;
  e.target.value = value;

  // --- 영업자 코드 수정 시 재검증 필요
  if (refName === "salespersonCodeText") {
    isCheckedSalespersonCode.value = false;
  }
};

// --- 비밀번호 규칙: 8~16자, 대문자/소문자/숫자/특수문자 포함
const passwordRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-={}[\]|\\:;"'<>,.?/]).{8,16}$/;

const validatePassword = () => {
  if (!passwordText.value) {
    passwordError.value = "";
    validatePassword2();
    return;
  }

  if (!passwordRegex.test(passwordText.value)) {
    passwordError.value =
      "8~16자의 대문자, 소문자, 숫자, 특수문자를 모두 포함해야 합니다.";
  } else {
    passwordError.value = "";
  }

  // --- 비밀번호 변경 시 확인란도 재검사
  validatePassword2();
};

const validatePassword2 = () => {
  if (!password2Text.value) {
    password2Error.value = "";
    return;
  }

  if (passwordText.value !== password2Text.value) {
    password2Error.value = "비밀번호가 일치하지 않습니다.";
  } else {
    password2Error.value = "";
  }
};

// --- 휴대폰 번호 중복확인
const handleCheckPhoneNumber = () =>
  runLocked(async () => {
    if (
      phone1Text.value.length !== 3 ||
      phone2Text.value.length !== 4 ||
      phone3Text.value.length !== 4
    ) {
      alert("휴대폰 번호를 정확하게 입력해주시기 바랍니다!");
      return;
    }

    const phoneText = getPhoneText();

    const docsSnap = await getDocs(
      query(collection(db, "users"), where("userPhone", "==", phoneText))
    );

    if (!docsSnap.empty) {
      alert("이미 등록된 전화번호입니다!");
      isNotPhoneDuplicated.value = false;
      return;
    }

    isNotPhoneDuplicated.value = true;
    alert("사용 가능한 전화번호입니다.");
  }).catch((e) => {
    console.error("휴대폰 번호 중복확인 실패:", e);
    isNotPhoneDuplicated.value = false;
    alert("중복확인 중 오류가 발생했습니다.");
  });

// --- 간편인증 요청 (1차)
const handleRequestLogin = () =>
  runLocked(async () => {
    if (!isNotPhoneDuplicated.value) {
      alert("휴대폰 번호 중복확인을 진행해주세요!");
      return;
    }

    if (
      !verifyNameText.value ||
      verifyRrn1Text.value.length !== 6 ||
      verifyRrn2Text.value.length !== 7
    ) {
      alert("주민등록증 정보를 입력해주세요!");
      return;
    }

    if (!loginTypeText.value) {
      alert("간편인증 종류를 선택해주세요!");
      return;
    }

    // --- 통신사 필요한 인증수단이면 통신사 필수
    if (needsCarrier(loginTypeText.value) && !carrierText.value) {
      alert("통신사를 선택해주세요!");
      return;
    }

    if (!isOverYear20(verifyRrn1Text.value)) {
      alert("20세 미만의 청소년은 가입이 불가합니다!");
      return;
    }

    const payload = buildResidentPayload();
    const convertResult = await parseCodefResult(payload);

    // --- 응답 코드 에러 처리 (필요시 추가)
    if (
      convertResult?.result?.code &&
      convertResult.result.code !== "CF-00000"
    ) {
      // --- 성공코드가 다를 수 있어 상세 정책에 맞게 조정
      console.warn(
        "CODEF 응답 코드:",
        convertResult.result.code,
        convertResult
      );
    }

    const tempTwoWayInfo = {
      jobIndex: convertResult?.data?.jobIndex ?? "",
      threadIndex: convertResult?.data?.threadIndex ?? "",
      jti: convertResult?.data?.jti ?? "",
      twoWayTimestamp: convertResult?.data?.twoWayTimestamp ?? "",
    };

    if (!tempTwoWayInfo.jobIndex || !tempTwoWayInfo.threadIndex) {
      throw new Error("2차 인증 정보(twoWayInfo) 응답이 없습니다.");
    }

    twoWayInfo.value = tempTwoWayInfo;
    isRequestLogin.value = true;
    isSuccessLogin.value = false;

    alert(
      "간편인증을 요청했습니다!\n알림을 통해 인증 진행 후 인증 완료하기 버튼을 눌러주세요!"
    );
  }).catch((error) => {
    console.error("간편인증 요청 실패:", error);
    twoWayInfo.value = {};
    isRequestLogin.value = false;
    isSuccessLogin.value = false;
    alert("인증 요청에 실패했습니다!");
  });

// --- 간편인증 완료 확인 (2차)
const handleSuccessLogin = () =>
  runLocked(async () => {
    if (!isRequestLogin.value || !twoWayInfo.value?.jobIndex) {
      alert("먼저 인증 요청을 진행해주세요!");
      return;
    }

    const payload = buildResidentPayload({ includeTwoWay: true });
    const convertResult = await parseCodefResult(payload);

    if (convertResult?.result?.code === "CF-03002") {
      alert("간편인증이 완료되지 않았습니다!\n휴대폰 알림을 확인해주세요!");
      return;
    }

    if (convertResult?.result?.code === "CF-12872") {
      alert(
        "간편인증이 확인되지 않아 만료되었습니다!\n다시 인증 요청해주세요!"
      );
      twoWayInfo.value = {};
      isRequestLogin.value = false;
      isSuccessLogin.value = false;
      return;
    }

    if (convertResult?.resAuthenticity === "0") {
      alert(
        "해당 신분증은 유효한 신분증이 아닙니다!\n내용을 확인 후 다시 인증해주세요!"
      );
      twoWayInfo.value = {};
      isRequestLogin.value = false;
      isSuccessLogin.value = false;
      return;
    }

    verifiedInfo.value = convertResult;
    twoWayInfo.value = {};
    isRequestLogin.value = true;
    isSuccessLogin.value = true;

    alert("간편인증이 완료되었습니다!\n회원가입을 계속 진행해주세요!");
  }).catch((error) => {
    console.error("간편인증 완료 확인 실패:", error);
    twoWayInfo.value = {};
    isRequestLogin.value = false;
    isSuccessLogin.value = false;
    alert("인증에 실패했습니다!\n다시 인증 요청해주세요!");
  });

// --- 다음 우편번호 팝업
const openDaumPostcode = () => {
  if (!window?.daum?.Postcode) {
    alert(
      "주소 검색 스크립트가 아직 로드되지 않았습니다. 잠시 후 다시 시도해주세요."
    );
    return;
  }

  new window.daum.Postcode({
    oncomplete: (data) => {
      let extraAddr = "";

      // --- 도로명 주소일 때 참고항목 조합
      if (data.addressType === "R") {
        if (data.bname) extraAddr += data.bname;
        if (data.buildingName) {
          extraAddr += extraAddr ? `, ${data.buildingName}` : data.buildingName;
        }
      }

      postCodeText.value = data.zonecode;
      address1Text.value = data.address;
      address2Text.value = extraAddr ? `(${extraAddr}) ` : "";

      // --- 상세주소 입력칸으로 포커스 이동
      nextTick(() => {
        document.querySelector('input[placeholder="상세 주소 입력"]')?.focus();
      });
    },
  }).open();
};

// --- 영업자 코드 확인
const checkSalesPersonCode = () =>
  runLocked(async () => {
    if (!salespersonCodeText.value) {
      alert("영업자 코드를 입력해주세요!");
      return;
    }

    const salespersonDocs = await getDocs(
      query(
        collection(db, "salespersons"),
        where("salespersonId", "==", salespersonCodeText.value)
      )
    );

    if (salespersonDocs.empty) {
      isCheckedSalespersonCode.value = false;
      alert("해당하는 영업자가 없습니다!");
      return;
    }

    isCheckedSalespersonCode.value = true;
    alert("영업자가 확인되었습니다!");
  }).catch((e) => {
    console.error("영업자 코드 확인 실패:", e);
    isCheckedSalespersonCode.value = false;
    alert("영업자 코드 확인 중 오류가 발생했습니다!");
  });

// --- 회원가입 제출
const nextStep = () =>
  runLocked(async () => {
    // --- 현재 구조는 모든 체크를 필수로 처리 (정책에 맞게 변경 가능)
    const allRequiredChecked = Object.values(checks.value).every(
      (v) => v === true
    );
    if (!allRequiredChecked) {
      alert("필수 항목을 모두 체크해주세요!");
      return;
    }

    if (!isNotPhoneDuplicated.value) {
      alert("휴대폰 번호 중복체크를 진행해주세요!");
      return;
    }

    if (
      passwordError.value ||
      password2Error.value ||
      !passwordText.value ||
      !password2Text.value ||
      passwordText.value !== password2Text.value
    ) {
      alert("비밀번호가 일치하지 않거나 문제가 있습니다!");
      return;
    }

    if (!isSuccessLogin.value) {
      alert("본인 인증을 진행해주세요!");
      return;
    }

    if (!postCodeText.value || !address1Text.value) {
      alert("주소를 입력해주세요!");
      return;
    }

    if (
      !bankNameText.value ||
      !bankAccountNumberText.value ||
      !bankDepositorNameText.value
    ) {
      alert("환불 계좌 정보를 입력해주세요!");
      return;
    }

    // --- 영업자 코드 미검증이면 빈 값으로 저장
    if (!isCheckedSalespersonCode.value) {
      salespersonCodeText.value = "";
    }

    const now = Timestamp.fromDate(new Date());
    const userPhone = getPhoneText();
    const uuid = await generateUUIDFromSeed(userPhone);

    // --- 최종 중복 방어 (버튼 연타/동시가입 등)
    const existUserSnap = await getDoc(doc(db, "users", uuid));
    if (existUserSnap.exists()) {
      alert("이미 가입된 회원입니다.");
      return;
    }

    await setDoc(doc(db, "users", uuid), {
      userId: uuid,
      userName: verifyNameText.value,
      userPhone,
      userPassword: encrypt(passwordText.value), // --- encrypt가 async면 await 추가
      userVerifiedInfo: encrypt(JSON.stringify(verifiedInfo.value)),
      userGrade: isCheckedSalespersonCode.value ? "N5" : "N1",
      userMinGrade: isCheckedSalespersonCode.value ? "N5" : "N1",
      userBirthday: convertRRNtoDate(verifyRrn1Text.value),
      userPostCode: postCodeText.value,
      userAddress1: address1Text.value,
      userAddress2: address2Text.value,
      userBankName: bankNameText.value,
      userBankAccountNumber: bankAccountNumberText.value,
      userBankDepositorName: bankDepositorNameText.value,
      userCardNumber: "",
      userCardValidDate: null,
      userSalespersonCode: salespersonCodeText.value,
      userProductCartList: [],
      userProductWishList: [],
      isAdmin: false,
      termsAcceptedAt: now,
      privacyAcceptedAt: now,
      gpsAcceptedAt: now,
      marketingAcceptedAt: now,
      smsAcceptedAt: now,
      visitedAt: now,
      createdAt: now,
    });

    await addDoc(collection(db, "userPoints"), {
      actionType: "ADD",
      afterPoint: 3000,
      amount: 3000,
      beforePoint: 0,
      createdAt: now,
      description: "회원가입으로 인한 가입 축하 적립금 3,000 냥코인 적립",
      sourceType: "JOIN_REWARD",
      userId: uuid,
    });

    if (isCheckedSalespersonCode.value && salespersonCodeText.value) {
      await updateDoc(doc(db, "salespersons", salespersonCodeText.value), {
        userIds: arrayUnion(uuid),
      });
    }

    await loginProcess(uuid);
    window.location.href = "/member/join-success";
  }).catch((e) => {
    console.error("회원가입 실패:", e);
    alert("회원가입 중 오류가 발생했습니다!");
  });

// --- 약관/정책 다이얼로그 열기
const openDialog = (docId) =>
  runLocked(async () => {
    const snap = await getDoc(doc(db, "settings", docId));

    if (!snap.exists()) {
      alert("설정 정보를 찾을 수 없습니다.");
      return;
    }

    const data = snap.data();
    dialogTitle.value = data.title ?? "";
    dialogContent.value = data.content ?? "";
    isDialogOpened.value = true;
  }).catch((e) => {
    console.error("다이얼로그 로딩 실패:", e);
    alert("약관 내용을 불러오지 못했습니다.");
  });

// --- 다이얼로그 닫기
const closeDialog = () => {
  isDialogOpened.value = false;
};

// --- 진입 시 영업자 코드가 쿼리로 들어오면 자동 세팅
onMounted(() => {
  runLocked(async () => {
    const id = String(route.query.id || "");
    if (!id) return;

    const salespersonDocs = await getDocs(
      query(collection(db, "salespersons"), where("salespersonId", "==", id))
    );

    if (salespersonDocs.empty) return;

    salespersonCodeText.value = id;
    isCheckedSalespersonCode.value = true;
  }).catch((e) => {
    console.error("초기 영업자 코드 확인 실패:", e);
  });
});
</script>

<style lang="scss" scoped>
.member-agreement {
  padding: 36px 24px;
  margin: auto;
  width: 100%;
  min-height: 70vh;

  button:disabled {
    background-color: #666 !important;
    border-color: #666 !important;
    cursor: not-allowed !important;
  }

  > .inner-container {
    width: 100%;
    margin: auto;
    > h2 {
      text-align: center;
      margin-bottom: 16px;
    }

    > .agreement-container {
      margin-top: 24px;
      > hr {
        border: none;
        border-top: 3px solid black;
        margin: 24px 0;

        &.sub {
          border-top: 1px solid #999;
        }
      }

      > .checkbox-container {
        display: flex;
        align-items: center;
        gap: 16px;

        &:not(:first-child) {
          margin-top: 8px;
        }

        > div {
          &.label-container {
            flex: 1;
          }

          > input {
            width: 20px;
            height: 20px;
          }

          > label {
            font-size: 16px;
            line-height: 20px;
            word-break: keep-all;
            &.bold {
              font-weight: 700;
            }
          }

          > p {
            font-size: 14px;
            margin-top: 4px;
            color: #999;
          }
        }

        > button {
          border: none;
          background: #007bff;
          color: white;
          font-weight: 700;
          padding: 8px 12px;
          border-radius: 8px;
          cursor: pointer;

          &:hover {
            filter: brightness(1.15);
          }
        }
      }

      > .button-container {
        display: flex;
        align-items: center;
        gap: 24px;

        > button {
          flex: 1;
          background: none;
          border: none;
          border-radius: 8px;
          padding: 12px 24px;
          font-size: 18px;
          cursor: pointer;

          &:first-child {
            border: 1px solid black;
          }

          &:last-child {
            border: 1px solid #007bff;
            background-color: #007bff;
            font-weight: 700;
            color: white;
          }
        }
      }
    }

    > .join-container {
      margin-top: 48px;
      > hr {
        border: none;
        border-top: 3px solid black;
        margin: 24px 0;

        &.sub {
          border-top: 1px solid #999;
        }
      }

      > img {
        width: 100%;
        margin-top: 24px;
      }

      button.side-button {
        min-width: 128px;
        width: fit-content;
        height: 38px;
        margin-top: 8px;
        border: none;
        border-radius: 8px;
        font-size: 16px;
        cursor: pointer;
        border: 1px solid #007bff;
        background-color: #007bff;
        font-weight: 700;
        color: white;
      }

      > .input-container {
        margin-top: 16px;
        > p {
          &.error {
            margin-top: 8px;
            color: red;
            font-weight: 700;
            font-size: 14px;
          }

          > span {
            margin-left: 6px;
            font-weight: 700;
            color: #007bff;
          }
        }

        &.flex {
          display: flex;
          align-items: center;
          gap: 24px;

          > div {
            display: flex;
            align-items: center;
            gap: 8px;
          }
        }

        &.rrn {
          > div {
            display: flex;
            align-items: center;
            gap: 8px;

            > input {
              width: 100%;
              margin-top: 8px;
              padding: 8px 12px;
              font-size: 16px;
              border-radius: 8px;
              border: 1px solid #999;
            }
          }
        }

        > input,
        select {
          width: 100%;
          margin-top: 8px;
          padding: 8px 12px;
          font-size: 16px;
          border-radius: 8px;
          border: 1px solid #999;
        }

        > button {
          margin-top: 12px;
          background: none;
          border: none;
          border-radius: 8px;
          min-height: 38px;
          font-size: 16px;
          cursor: pointer;
          border: 1px solid #007bff;
          background-color: #007bff;
          font-weight: 700;
          color: white;
          width: 100%;
        }
      }

      > .button-container {
        display: flex;
        align-items: center;
        gap: 24px;

        > button {
          flex: 1;
          background: none;
          border: none;
          border-radius: 8px;
          padding: 12px 24px;
          font-size: 16px;
          cursor: pointer;

          &:first-child {
            border: 1px solid black;
          }

          &:last-child {
            border: 1px solid #007bff;
            background-color: #007bff;
            font-weight: 700;
            color: white;
          }
        }
      }
    }
  }

  > .overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5); /* 🔥 배경 어둡게 */
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;

    > .modal {
      background: #fff;
      width: 90%;
      max-width: 540px;
      border-radius: 8px;
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);

      > .title-container {
        display: flex;
        align-items: center;
        padding: 16px 24px;

        > h3 {
          flex: 1;
        }

        > .close-button {
          background: none;
          border: none;
          cursor: pointer;

          &:hover {
            filter: brightness(1.15);
          }
        }
      }

      > .content-container {
        padding: 16px 24px;
        max-height: 70vh;
        overflow-y: scroll;
      }
    }
  }
}
</style>
